import Vue from 'vue'

Vue.directive('money-format', (el, { value }) => {
  console.log(value)
})
